import { useCallback, useEffect } from "react";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersFAQForm, {
	applyFAQLocalizableChanges,
	VolunteersFAQGeneralValues,
	VolunteersFAQLocalizableChanges,
} from "../../components/VolunteersFAQForm";
import { useVolunteersFAQContext } from "../../context/VolunteersFAQContext/VolunteersFAQContext";
import { VOLUNTEERS_FAQ_LIST_PATH } from "../../context/VolunteersFAQContext/constants";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const AddVolunteersFAQ = () => {
	const {
		addVolunteersFAQ,
		clearVolunteersFAQFormData,
		volunteersFAQForm,
		setVolunteersFAQForm,
		operationStatus,
	} = useVolunteersFAQContext();

	useEffect(() => {
		clearVolunteersFAQFormData();

		return () => {
			clearVolunteersFAQFormData();
		};
	}, [clearVolunteersFAQFormData]);

	const handleGeneralChange = useCallback((changes: Partial<VolunteersFAQGeneralValues>) => {
		setVolunteersFAQForm(prev => ({ ...prev, ...changes }));
	}, [setVolunteersFAQForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: VolunteersFAQLocalizableChanges) => {
		setVolunteersFAQForm(prev => ({
			...prev,
			volunteersFAQLocalizable: applyFAQLocalizableChanges(prev.volunteersFAQLocalizable, culture, changes),
		}));
	}, [setVolunteersFAQForm]);

	return (
		<>
			<BackComponent text="Merak Edilenler Listesine Dön" to={VOLUNTEERS_FAQ_LIST_PATH} />
			<ActionContainer>
				<ActionItemsContainer>
					<FormHeaderComponent>Merak Edilen Ekleme</FormHeaderComponent>
					<VolunteersFAQForm
						general={volunteersFAQForm}
						localizables={volunteersFAQForm.volunteersFAQLocalizable}
						isRequired
						onGeneralChange={handleGeneralChange}
						onLocalizableChange={handleLocalizableChange}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent
							onClick={addVolunteersFAQ}
							loading={operationStatus.type === "loading" && operationStatus.operation === "add"}
						>
							Merak Edilen Ekle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</ActionContainer>
		</>
	);
};

export default AddVolunteersFAQ;
